import RankingFutbolero from "./RankingFutbolero";

export default function RankingFutbolero2() {
  return (
    <RankingFutbolero
      titulo="Rank Futbolero Dinámica 2"
      descripcion="13 de junio – 31 de julio"
      notaPremio="Top 10 por zona · Premio: obsequio"
      tipoCampana="futbolero2"
      mesesCierre={6}
      columnaValorLabel="Ventas"
      agruparPorZona
    />
  );
}
